import photoJeongWoojin from '../../../../images/resumesample/asset_60121120-1377-48c0-bfb9-c0e4218a28a3_1790401643970.jpeg';
import photoJoMiyoung from '../../../../images/resumesample/asset_d38f08ca-a96c-4c0d-8c61-2d71887d8e47_1790401643970.jpeg';
import photoLimDaniel from '../../../../images/resumesample/asset_fr1xsqysu_1790401643970.jpeg';
import photoHongMina from '../../../../images/resumesample/asset_g4j5l0zda_1790401643970.jpeg';
import photoSeoJaewon from '../../../../images/resumesample/asset_kv55ms8on_1790401643970.jpeg';
import photoKimEunhye from '../../../../images/resumesample/asset_myvmyro4p_1790401643970.jpeg';
import photoYuHaeun from '../../../../images/resumesample/asset_ooh73qr8i_1790401643970.jpeg';
import photoLeeHangyeol from '../../../../images/resumesample/asset_q8gd93a21_1790401643970.jpeg';
import photoHanSomang from '../../../../images/resumesample/asset_ytlgu2skg_1790401643970.jpeg';
import photoParkSungmin from '../../../../images/resumesample/asset_yxiutk1m2_1790401643970.jpeg';
import photoShinHaneul from '../../../../images/resumesample/asset_46g90o0yp_1790402027991.jpeg';
import photoOhJunhyuk from '../../../../images/resumesample/asset_4kcz9yih7_1790402027991.jpeg';
import photoMoonGaeun from '../../../../images/resumesample/asset_52f3txjl8_1790402027991.jpeg';
import photoKwonDoyoon from '../../../../images/resumesample/asset_b9544e67-a44b-4dc6-94e9-5440f9d7fb24_1790402027991.jpeg';
import photoKangYerin from '../../../../images/resumesample/asset_erhx028bj_1790402027991.jpeg';
import photoJangYohan from '../../../../images/resumesample/asset_fgj9uqood_1790402027991.jpeg';
import photoNaEunji from '../../../../images/resumesample/asset_g1ztohzzt_1790402027991.jpeg';
import photoYoonTaeho from '../../../../images/resumesample/asset_hu2p9tqex_1790402027991.jpeg';
import photoChoiJihyun from '../../../../images/resumesample/asset_iu4fbwo54_1790402027991.jpeg';
import photoBaeSion from '../../../../images/resumesample/asset_q8p4e1vwz_1790402027991.jpeg';
import logoPng from '../../../../images/logopng.png';
import { mockMinistryPhoto, mockSermonThumb, mockWorshipThumb } from './mockMedia';
import type { MinisterInfoDetail, MinisterInfoListItem, PortfolioItem, SelfIntroItem } from './ministerInfoTypes';

// 임시 목데이터 — 실제 공개 이력서(최신순) 뒤에 이어 붙인다. false 면 서버 데이터만 사용
export const USE_MINISTER_MOCK = false;

export const MOCK_ID_PREFIX = 'mock-';


// 샘플 증명사진 20장 — 기존 20명은 1인 1장, 추가 40명은 EXTRA_PHOTO_REFS 로 재사용
const SAMPLE_PHOTOS: Record<string, string> = {
  정우진: photoJeongWoojin,
  서재원: photoSeoJaewon,
  박성민: photoParkSungmin,
  임다니엘: photoLimDaniel,
  이한결: photoLeeHangyeol,
  조미영: photoJoMiyoung,
  홍민아: photoHongMina,
  김은혜: photoKimEunhye,
  유하은: photoYuHaeun,
  한소망: photoHanSomang,
  오준혁: photoOhJunhyuk,
  장요한: photoJangYohan,
  권도윤: photoKwonDoyoon,
  윤태호: photoYoonTaeho,
  배시온: photoBaeSion,
  최지현: photoChoiJihyun,
  신하늘: photoShinHaneul,
  문가은: photoMoonGaeun,
  강예린: photoKangYerin,
  나은지: photoNaEunji,
};

// 추가 40명의 증명사진 — 성별·연령대가 비슷한 기존 샘플 사진을 재사용
const EXTRA_PHOTO_REFS: Record<string, string> = {
  김하람: '박성민', 이수아: '신하늘', 박준서: '박성민', 정예은: '유하은', 최민혁: '권도윤',
  한지우: '문가은', 송재혁: '정우진', 윤서진: '홍민아', 장민우: '이한결', 오하린: '나은지',
  임성훈: '윤태호', 김다은: '김은혜', 조현우: '윤태호', 신예진: '한소망', 백승현: '장요한',
  류지안: '강예린', 남궁현: '배시온', 안소영: '조미영', 홍재민: '임다니엘', 김나래: '신하늘',
  이동건: '박성민', 서하윤: '유하은', 강태민: '정우진', 정다인: '홍민아', 문성진: '권도윤',
  양은서: '문가은', 구본석: '서재원', 최하늘: '김은혜', 권혁준: '임다니엘', 황보라: '나은지',
  노승민: '이한결', 엄지혜: '홍민아', 차윤호: '윤태호', 길소연: '한소망', 표진우: '오준혁',
  봉하은: '강예린', 마준영: '배시온', 진서영: '최지현', 탁현수: '임다니엘', 우예슬: '신하늘',
};

function samplePhotoOf(name: string) {
  return SAMPLE_PHOTOS[name] || SAMPLE_PHOTOS[EXTRA_PHOTO_REFS[name]] || '';
}

type Seed = [
  name: string, gender: string, birth: string, address: string,
  title: string,
  edu: [school: string, major: string, start: string, end: string, status: string][],
  career: [company: string, position: string, start: string, end: string, desc: string][],
  hopeType: string, hopeLocation: string, hopeSalary: string, hopeRoles: string, hopeDepartment: string,
  updatedAt: string,
];

const SEEDS: Seed[] = [
  ['김은혜', '여', '1994.03.12', '서울특별시 강남구 역삼동', '다음세대를 사랑하는 교육전도사입니다',
    [['장로회신학대학교 신학대학원', '목회학석사(M.Div.)', '2019.03', '2022.02', '졸업'], ['이화여자대학교', '기독교학과', '2013.03', '2017.02', '졸업']],
    [['서울은혜교회', '교육전도사', '2022.03', '2025.12', '유치부·유년부 담당, 여름성경학교 기획'], ['새소망교회', '교육전도사', '2019.09', '2022.02', '초등부 담당']],
    '파트', '서울특별시, 경기도', '150', '교육전도사', '유치부, 유년부', '2026.09.24'],
  ['박성민', '남', '1988.07.05', '경기도 성남시 분당구', '청년부 사역 7년차, 전임 부목사 지원합니다',
    [['총신대학교 신학대학원', '목회학석사(M.Div.)', '2014.03', '2017.02', '졸업'], ['연세대학교', '경영학과', '2007.03', '2013.02', '졸업']],
    [['분당중앙교회', '부목사', '2019.03', '2026.06', '청년부 담당, 제자훈련 인도'], ['수원제일교회', '전도사', '2015.03', '2019.02', '중고등부 담당']],
    '전임', '경기도, 서울특별시', '350', '부목사', '청년부', '2026.09.23'],
  ['이한결', '남', '1996.11.20', '인천광역시 연수구 송도동', '찬양과 예배로 섬기는 찬양사역자',
    [['한세대학교', '교회음악학과', '2015.03', '2021.02', '졸업']],
    [['인천비전교회', '찬양인도자', '2021.03', '2026.08', '주일 2부·청년예배 찬양인도, 찬양팀 훈련']],
    '준전임', '인천광역시, 서울특별시', '220', '찬양사역자', '청년부, 장년부', '2026.09.22'],
  ['최지현', '여', '1974.01.28', '대전광역시 유성구', '자녀를 키운 뒤 소명을 받아 가정·상담 사역을 섬기는 전도사',
    [['침례신학대학교 신학대학원', '기독교상담학', '2017.03', '2020.02', '졸업'], ['한남대학교', '사회복지학과', '1993.03', '1997.02', '졸업']],
    [['대전한빛교회', '전도사', '2020.03', '2026.02', '새가족부·상담사역'], ['유성사랑교회', '교육전도사', '2017.09', '2020.02', '중등부']],
    '전임', '대전광역시, 세종특별자치시', '280', '전도사', '새가족부, 장년부', '2026.09.21'],
  ['정우진', '남', '1975.04.17', '부산광역시 해운대구', '선교 경험을 가진 담임목사 후보자',
    [['고신대학교 신학대학원', '목회학석사(M.Div.)', '2010.03', '2013.02', '졸업'], ['Fuller Theological Seminary', '선교학(Th.M.)', '2016.09', '2018.06', '졸업']],
    [['필리핀 마닐라 한인교회', '선교사', '2018.07', '2023.12', '현지 교회개척 및 신학교 강의'], ['부산동래교회', '부목사', '2013.03', '2018.06', '청년부·선교부']],
    '전임', '부산광역시, 경상남도', '400', '담임목사', '장년부', '2026.09.20'],
  ['한소망', '여', '1998.06.09', '경기도 고양시 일산동구', '아이들과 함께 자라는 교육전도사',
    [['서울신학대학교', '신학과', '2017.03', '2021.02', '졸업'], ['서울신학대학교 신학대학원', '목회학석사(M.Div.)', '2023.03', '', '재학']],
    [['일산새빛교회', '교육전도사', '2021.03', '2026.07', '유년부·초등부 담당']],
    '파트', '경기도', '130', '교육전도사', '유년부, 초등부', '2026.09.19'],
  ['윤태호', '남', '1990.09.30', '서울특별시 마포구', '영상·미디어 사역 가능한 전도사입니다',
    [['감리교신학대학교 신학대학원', '목회학석사(M.Div.)', '2016.03', '2019.02', '졸업'], ['홍익대학교', '시각디자인학과', '2009.03', '2015.02', '졸업']],
    [['마포감리교회', '전도사', '2019.03', '2026.05', '미디어팀 운영, 온라인 예배 송출'], ['신촌교회', '교육전도사', '2016.03', '2019.02', '고등부']],
    '준전임', '서울특별시', '230', '전도사, 미디어사역', '청년부, 미디어부', '2026.09.18'],
  ['강예린', '여', '1993.12.02', '광주광역시 서구', '반주와 성가대 지휘가 가능한 음악사역자',
    [['광신대학교', '교회음악과', '2012.03', '2016.02', '졸업'], ['전남대학교 대학원', '음악학(피아노)', '2016.03', '2018.02', '졸업']],
    [['광주중앙교회', '반주자', '2018.03', '2026.08', '주일 대예배 반주, 성가대 지휘보조']],
    '파트', '광주광역시, 전라남도', '120', '반주자, 지휘자', '성가대', '2026.09.17'],
  ['오준혁', '남', '1972.02.14', '대구광역시 수성구', '제자훈련 사역 25년, 장년 목양에 집중하는 부목사',
    [['대신대학교 신학대학원', '목회학석사(M.Div.)', '1998.03', '2001.02', '졸업']],
    [['대구동신교회', '부목사', '2008.03', '2026.08', '장년 제자훈련, 구역 관리'], ['경산제일교회', '전도사', '2001.03', '2008.02', '청년부']],
    '전임', '대구광역시, 경상북도', '330', '부목사', '장년부, 교구', '2026.09.16'],
  ['신하늘', '여', '1997.08.21', '세종특별자치시 나성동', '청소년과 소통하는 중고등부 전도사',
    [['백석대학교', '기독교교육과', '2016.03', '2020.02', '졸업'], ['백석대학교 신학대학원', '목회학석사(M.Div.)', '2021.03', '2024.02', '졸업']],
    [['세종꿈의교회', '교육전도사', '2021.03', '2026.06', '중고등부 담당, 수련회 기획']],
    '준전임', '세종특별자치시, 충청남도, 대전광역시', '200', '전도사', '중등부, 고등부', '2026.09.15'],
  ['임다니엘', '남', '1992.05.03', '서울특별시 송파구', '영어예배·EM 사역 경험자',
    [['Biola University', 'Biblical Studies', '2011.09', '2015.06', '졸업'], ['Talbot School of Theology', 'M.Div.', '2015.09', '2019.05', '졸업']],
    [['잠실한인연합교회', 'EM 담당 전도사', '2020.01', '2026.08', '영어예배 설교, 청년 소그룹']],
    '전임', '서울특별시, 경기도', '300', '전도사, 영어예배', '청년부, 영어예배부', '2026.09.14'],
  ['조미영', '여', '1974.10.11', '경기도 수원시 영통구', '여성·권사회 사역을 섬겨온 전도사',
    [['협성대학교 신학대학원', '목회학석사(M.Div.)', '2008.03', '2011.02', '졸업']],
    [['수원영광교회', '전도사', '2014.03', '2026.04', '여전도회, 심방, 새가족 양육'], ['화성사랑교회', '전도사', '2011.03', '2014.02', '유치부']],
    '전임', '경기도', '270', '전도사, 심방', '여전도회, 장년부', '2026.09.13'],
  ['배시온', '남', '1995.01.19', '충청북도 청주시 흥덕구', '성실하게 섬기는 초등부 교육전도사',
    [['서울장신대학교', '신학과', '2014.03', '2020.02', '졸업'], ['장로회신학대학교 신학대학원', '목회학석사(M.Div.)', '2024.03', '', '재학']],
    [['청주상당교회', '교육전도사', '2020.03', '2026.08', '초등부 담당']],
    '파트', '충청북도, 세종특별자치시', '140', '교육전도사', '초등부', '2026.09.12'],
  ['홍민아', '여', '1990.04.25', '울산광역시 남구', '상담학 전공, 청년 돌봄 사역',
    [['고신대학교', '기독교상담학과', '2009.03', '2013.02', '졸업'], ['고신대학교 신학대학원', '목회학석사(M.Div.)', '2015.03', '2018.02', '졸업']],
    [['울산새중앙교회', '전도사', '2018.03', '2026.07', '청년부 상담, 소그룹 리더 훈련']],
    '준전임', '울산광역시, 부산광역시', '210', '전도사, 상담', '청년부', '2026.09.11'],
  ['서재원', '남', '1973.08.08', '경상남도 창원시 성산구', '교회 행정과 재정에 강점이 있는 부목사',
    [['영남신학대학교 신학대학원', '목회학석사(M.Div.)', '2008.03', '2011.02', '졸업'], ['부산대학교', '회계학과', '1992.03', '1996.02', '졸업']],
    [['창원한마음교회', '행정 부목사', '2015.03', '2026.08', '교회 행정·재정 총괄, 건축위원회'], ['마산제일교회', '부목사', '2011.03', '2015.02', '교구']],
    '전임', '경상남도, 부산광역시', '380', '부목사, 행정', '행정부, 교구', '2026.09.10'],
  ['문가은', '여', '1999.02.16', '전북특별자치도 전주시 완산구', '유아부를 섬기는 신학생 교육전도사',
    [['한일장신대학교', '신학과', '2018.03', '2022.02', '졸업'], ['한일장신대학교 신학대학원', '목회학석사(M.Div.)', '2023.03', '', '재학']],
    [['전주바울교회', '교육전도사', '2022.03', '2026.08', '영아부·유아부']],
    '파트', '전북특별자치도', '110', '교육전도사', '영아부, 유아부', '2026.09.09'],
  ['장요한', '남', '1972.12.24', '강원특별자치도 원주시', '농어촌 목회와 지역 섬김에 비전이 있습니다',
    [['감리교신학대학교 신학대학원', '목회학석사(M.Div.)', '1996.03', '1999.02', '졸업']],
    [['원주중앙감리교회', '부목사', '2009.03', '2026.08', '지역아동센터 연계 사역'], ['횡성시골교회', '전도사', '1999.03', '2009.02', '장년 목회 보조']],
    '전임', '강원특별자치도, 충청북도', '290', '부목사', '장년부, 지역선교', '2026.09.08'],
  ['유하은', '여', '1995.07.07', '제주특별자치도 제주시', '워십·예배 기획 사역자',
    [['숭실대학교', '기독교학과', '2014.03', '2018.02', '졸업'], ['아세아연합신학대학교', '목회학석사(M.Div.)', '2019.03', '2022.02', '졸업']],
    [['제주성안교회', '예배기획 전도사', '2022.03', '2026.08', '예배 기획, 워십팀 운영']],
    '준전임', '제주특별자치도', '200', '전도사, 예배기획', '청년부, 예배부', '2026.09.07'],
  ['권도윤', '남', '1993.03.03', '경상북도 포항시 북구', '중고등부 7년, 수련회 전문 전도사',
    [['계명대학교', '기독교학과', '2012.03', '2018.02', '졸업'], ['대신대학교 신학대학원', '목회학석사(M.Div.)', '2018.03', '2021.02', '졸업']],
    [['포항제일교회', '전도사', '2019.03', '2026.08', '중고등부 담당, 연합수련회 기획'], ['경주성결교회', '교육전도사', '2017.03', '2019.02', '초등부']],
    '전임', '경상북도, 대구광역시', '280', '전도사', '중등부, 고등부', '2026.09.06'],
  ['나은지', '여', '1996.09.14', '충청남도 천안시 서북구', '장애인·소외계층 사역에 마음이 있는 전도사',
    [['한국성서대학교', '사회복지학과', '2015.03', '2019.02', '졸업'], ['침례신학대학교 신학대학원', '목회학석사(M.Div.)', '2020.03', '2023.02', '졸업']],
    [['천안늘사랑교회', '교육전도사', '2020.03', '2026.08', '사랑부(장애인부서) 담당']],
    '파트', '충청남도, 경기도', '140', '교육전도사', '사랑부', '2026.09.05'],
  // ── 추가 40명 (사진은 성별·연령대가 비슷한 기존 사진을 재사용 — EXTRA_PHOTO_REFS) ──
  ['김하람', '남', '1991.02.11', '서울특별시 노원구', '청년 제자훈련에 집중하는 부목사 후보',
    [['총신대학교 신학대학원', '목회학석사(M.Div.)', '2016.03', '2019.02', '졸업'], ['서울시립대학교', '행정학과', '2010.03', '2016.02', '졸업']],
    [['노원중앙교회', '전도사', '2019.03', '2026.08', '청년부 제자훈련, 소그룹 리더 양육']],
    '전임', '서울특별시, 경기도', '300', '부목사, 전도사', '청년부', '2026.09.04'],
  ['이수아', '여', '1997.05.23', '경기도 용인시 수지구', '유초등부 예배를 섬기는 교육전도사',
    [['장로회신학대학교', '기독교교육과', '2016.03', '2020.02', '졸업'], ['장로회신학대학교 신학대학원', '목회학석사(M.Div.)', '2022.03', '', '재학']],
    [['수지사랑교회', '교육전도사', '2020.03', '2026.08', '유년부·초등부 예배와 교사 교육']],
    '파트', '경기도, 서울특별시', '140', '교육전도사', '유년부, 초등부', '2026.09.03'],
  ['박준서', '남', '1986.10.02', '인천광역시 남동구', '전도와 새가족 정착에 강점이 있는 부목사',
    [['서울신학대학교 신학대학원', '목회학석사(M.Div.)', '2012.03', '2015.02', '졸업']],
    [['인천성결교회', '부목사', '2018.03', '2026.07', '새가족부·전도부 담당'], ['부평제일교회', '전도사', '2015.03', '2018.02', '청년부']],
    '전임', '인천광역시, 경기도', '360', '부목사', '새가족부, 전도부', '2026.09.02'],
  ['정예은', '여', '1995.08.14', '서울특별시 관악구', '찬양팀 보컬과 예배 인도가 가능한 사역자',
    [['백석예술대학교', '교회실용음악과', '2014.03', '2017.02', '졸업']],
    [['관악은혜교회', '찬양인도자', '2018.03', '2026.08', '청년예배 찬양인도, 보컬 트레이닝']],
    '파트', '서울특별시', '120', '찬양인도자', '청년부, 찬양팀', '2026.09.01'],
  ['최민혁', '남', '1994.04.30', '경기도 부천시 원미구', '중고등부를 사랑하는 전도사',
    [['성결대학교', '신학과', '2013.03', '2019.02', '졸업'], ['성결대학교 신학대학원', '목회학석사(M.Div.)', '2019.03', '2022.02', '졸업']],
    [['부천새생명교회', '전도사', '2020.03', '2026.08', '중고등부 담당, 여름수련회 기획']],
    '준전임', '경기도, 인천광역시', '210', '전도사', '중등부, 고등부', '2026.08.31'],
  ['한지우', '여', '1999.11.05', '대구광역시 달서구', '유아부 사역을 준비하는 신학생',
    [['계명대학교', '기독교학과', '2018.03', '2022.02', '졸업'], ['영남신학대학교 신학대학원', '목회학석사(M.Div.)', '2024.03', '', '재학']],
    [['달서제일교회', '교육전도사', '2022.09', '2026.08', '유아부 담당']],
    '파트', '대구광역시, 경상북도', '110', '교육전도사', '유아부', '2026.08.30'],
  ['송재혁', '남', '1978.06.19', '서울특별시 서초구', '교구 목양 15년, 장년 사역 전문 부목사',
    [['총신대학교 신학대학원', '목회학석사(M.Div.)', '2004.03', '2007.02', '졸업'], ['총신대학교 대학원', '신학석사(Th.M.)', '2008.03', '2010.02', '졸업']],
    [['서초사랑의교회', '부목사', '2011.03', '2026.06', '교구 담당, 장년 성경공부'], ['양재교회', '전도사', '2007.03', '2011.02', '청년부']],
    '전임', '서울특별시', '420', '부목사', '장년부, 교구', '2026.08.29'],
  ['윤서진', '여', '1992.03.08', '부산광역시 수영구', '청소년 상담과 양육을 섬기는 전도사',
    [['고신대학교', '기독교교육과', '2011.03', '2015.02', '졸업'], ['고신대학교 신학대학원', '목회학석사(M.Div.)', '2016.03', '2019.02', '졸업']],
    [['수영로교회', '전도사', '2019.03', '2026.08', '고등부 담당, 청소년 상담']],
    '전임', '부산광역시, 경상남도', '270', '전도사, 상담', '고등부', '2026.08.28'],
  ['장민우', '남', '1997.12.12', '광주광역시 북구', '영상 편집과 온라인 사역이 가능한 교육전도사',
    [['광신대학교', '신학과', '2016.03', '2022.02', '졸업']],
    [['광주새빛교회', '교육전도사', '2022.03', '2026.08', '청소년부, 온라인 예배 영상 제작']],
    '파트', '광주광역시, 전라남도', '130', '교육전도사, 미디어사역', '중등부, 미디어부', '2026.08.27'],
  ['오하린', '여', '1996.01.27', '경기도 성남시 수정구', '반주와 어린이 찬양을 섬기는 음악사역자',
    [['총신대학교', '교회음악과', '2015.03', '2019.02', '졸업']],
    [['성남중앙교회', '반주자', '2019.03', '2026.08', '주일 1부 반주, 어린이 찬양대 지도']],
    '파트', '경기도', '110', '반주자', '성가대, 유년부', '2026.08.26'],
  ['임성훈', '남', '1983.09.21', '대전광역시 서구', '행정과 교육부서 총괄 경험이 있는 부목사',
    [['침례신학대학교 신학대학원', '목회학석사(M.Div.)', '2009.03', '2012.02', '졸업'], ['충남대학교', '교육학과', '2002.03', '2008.02', '졸업']],
    [['대전새로남교회', '부목사', '2016.03', '2026.07', '교육부서 총괄, 교사대학'], ['둔산교회', '전도사', '2012.03', '2016.02', '중고등부']],
    '전임', '대전광역시, 충청남도', '350', '부목사, 교육', '교육부, 장년부', '2026.08.25'],
  ['김다은', '여', '1994.07.03', '서울특별시 은평구', '영유아부와 부모교육을 함께 섬기는 전도사',
    [['이화여자대학교', '유아교육과', '2013.03', '2017.02', '졸업'], ['감리교신학대학교 신학대학원', '목회학석사(M.Div.)', '2018.03', '2021.02', '졸업']],
    [['은평감리교회', '전도사', '2021.03', '2026.08', '영아부·유아부, 부모교육 세미나']],
    '준전임', '서울특별시, 경기도', '200', '전도사', '영아부, 유아부', '2026.08.24'],
  ['조현우', '남', '1989.05.16', '경상남도 김해시', '다문화·이주민 사역 경험자',
    [['부산장신대학교 신학대학원', '목회학석사(M.Div.)', '2014.03', '2017.02', '졸업']],
    [['김해이주민교회', '전도사', '2017.03', '2026.08', '이주민 예배, 한국어 교실 운영']],
    '전임', '경상남도, 부산광역시', '280', '전도사, 선교', '선교부, 장년부', '2026.08.23'],
  ['신예진', '여', '1998.09.09', '충청북도 청주시 서원구', '초등부 교사 교육에 관심 있는 교육전도사',
    [['서울신학대학교', '기독교교육과', '2017.03', '2021.02', '졸업']],
    [['청주서원교회', '교육전도사', '2021.03', '2026.08', '초등부 담당, 교사 모임 인도']],
    '파트', '충청북도', '120', '교육전도사', '초등부', '2026.08.22'],
  ['백승현', '남', '1973.03.25', '경기도 안양시 동안구', '개척 경험이 있는 담임목사 후보',
    [['장로회신학대학교 신학대학원', '목회학석사(M.Div.)', '1999.03', '2002.02', '졸업'], ['장로회신학대학교 대학원', '목회학박사(D.Min.)', '2012.03', '2015.02', '졸업']],
    [['안양소망교회', '담임목사', '2010.03', '2026.02', '교회 개척 및 목회'], ['평촌교회', '부목사', '2002.03', '2010.02', '교구']],
    '전임', '경기도, 서울특별시', '450', '담임목사', '장년부', '2026.08.21'],
  ['류지안', '여', '1993.04.18', '전북특별자치도 익산시', '워십댄스와 어린이 예배를 섬기는 사역자',
    [['한일장신대학교', '기독교교육과', '2012.03', '2016.02', '졸업']],
    [['익산중앙교회', '교육간사', '2016.03', '2026.08', '어린이 워십팀 지도, 유년부 예배']],
    '준전임', '전북특별자치도', '180', '교육간사, 워십', '유년부, 예배부', '2026.08.20'],
  ['남궁현', '남', '1995.06.07', '서울특별시 강서구', '영어·중국어 가능, 외국인 예배 사역자',
    [['한국외국어대학교', '중국어과', '2014.03', '2020.02', '졸업'], ['아세아연합신학대학교', '목회학석사(M.Div.)', '2020.03', '2023.02', '졸업']],
    [['강서온누리교회', '전도사', '2023.03', '2026.08', '중국어 예배, 외국인 유학생 사역']],
    '전임', '서울특별시', '290', '전도사, 외국어예배', '외국인부, 청년부', '2026.08.19'],
  ['안소영', '여', '1973.12.01', '경기도 안산시 단원구', '심방과 새가족 돌봄을 섬겨온 전도사',
    [['협성대학교 신학대학원', '목회학석사(M.Div.)', '2006.03', '2009.02', '졸업']],
    [['안산동산교회', '전도사', '2012.03', '2026.05', '심방, 새가족 양육, 권사회']],
    '전임', '경기도', '260', '전도사, 심방', '새가족부, 장년부', '2026.08.18'],
  ['홍재민', '남', '1992.08.28', '울산광역시 중구', '청년부 찬양과 설교를 함께 섬기는 전도사',
    [['고신대학교 신학대학원', '목회학석사(M.Div.)', '2017.03', '2020.02', '졸업'], ['울산대학교', '음악학과', '2011.03', '2017.02', '졸업']],
    [['울산제일교회', '전도사', '2020.03', '2026.08', '청년부 설교, 찬양팀 인도']],
    '준전임', '울산광역시, 경상남도', '220', '전도사, 찬양인도', '청년부', '2026.08.17'],
  ['김나래', '여', '1997.02.20', '인천광역시 서구', '장애인부서(사랑부)를 섬기는 교육전도사',
    [['한국성서대학교', '특수교육과', '2016.03', '2020.02', '졸업']],
    [['인천사랑교회', '교육전도사', '2020.03', '2026.08', '사랑부 예배, 가정 연계 돌봄']],
    '파트', '인천광역시', '130', '교육전도사', '사랑부', '2026.08.16'],
  ['이동건', '남', '1987.01.13', '경상북도 구미시', '제조업 현장 경험을 가진 직장인 사역 전도사',
    [['대신대학교 신학대학원', '목회학석사(M.Div.)', '2016.03', '2019.02', '졸업'], ['금오공과대학교', '기계공학과', '2006.03', '2012.02', '졸업']],
    [['구미남교회', '전도사', '2019.03', '2026.08', '직장인 소그룹, 청장년부']],
    '전임', '경상북도, 대구광역시', '280', '전도사', '청장년부', '2026.08.15'],
  ['서하윤', '여', '1995.10.10', '세종특별자치시 도담동', '청소년 캠프·수련회 기획 전문 사역자',
    [['백석대학교', '기독교교육과', '2014.03', '2018.02', '졸업'], ['백석대학교 신학대학원', '기독교교육학', '2019.03', '2021.02', '졸업']],
    [['세종주님의교회', '교육전도사', '2019.03', '2026.08', '중고등부, 연합 캠프 기획']],
    '준전임', '세종특별자치시, 대전광역시', '200', '교육전도사', '중등부, 고등부', '2026.08.14'],
  ['강태민', '남', '1976.07.07', '제주특별자치도 서귀포시', '섬 지역 목회와 지역 섬김에 비전이 있는 목사',
    [['감리교신학대학교 신학대학원', '목회학석사(M.Div.)', '2002.03', '2005.02', '졸업']],
    [['서귀포중앙교회', '부목사', '2012.03', '2026.08', '지역 봉사, 노인대학'], ['제주동부교회', '전도사', '2005.03', '2012.02', '장년부']],
    '전임', '제주특별자치도', '320', '부목사', '장년부, 지역선교', '2026.08.13'],
  ['정다인', '여', '1991.06.25', '서울특별시 성북구', '성경공부 교재 개발 경험이 있는 교육 전도사',
    [['숭실대학교', '기독교학과', '2010.03', '2014.02', '졸업'], ['총신대학교 신학대학원', '기독교교육학', '2015.03', '2018.02', '졸업']],
    [['성북제일교회', '전도사', '2018.03', '2026.08', '교육부 교재 개발, 교사 훈련']],
    '전임', '서울특별시, 경기도', '280', '전도사, 교육', '교육부', '2026.08.12'],
  ['문성진', '남', '1993.11.29', '강원특별자치도 춘천시', '대학 캠퍼스 사역 경험이 있는 청년 전도사',
    [['한림대학교', '영어영문학과', '2012.03', '2018.02', '졸업'], ['서울신학대학교 신학대학원', '목회학석사(M.Div.)', '2018.03', '2021.02', '졸업']],
    [['춘천성결교회', '전도사', '2021.03', '2026.08', '대학청년부, 캠퍼스 사역']],
    '준전임', '강원특별자치도', '210', '전도사', '대학부, 청년부', '2026.08.11'],
  ['양은서', '여', '1998.03.16', '경기도 파주시', '어린이 설교와 인형극 사역이 가능한 교육전도사',
    [['서울장신대학교', '기독교교육과', '2017.03', '2021.02', '졸업']],
    [['파주한빛교회', '교육전도사', '2021.03', '2026.08', '유치부 설교, 인형극팀 운영']],
    '파트', '경기도', '120', '교육전도사', '유치부', '2026.08.10'],
  ['구본석', '남', '1973.04.04', '대구광역시 중구', '행정·재정 총괄 경험의 행정목사',
    [['영남신학대학교 신학대학원', '목회학석사(M.Div.)', '1997.03', '2000.02', '졸업'], ['경북대학교', '경영학과', '1992.03', '1997.02', '졸업']],
    [['대구제일교회', '행정목사', '2008.03', '2026.08', '행정·재정·시설 총괄'], ['대봉교회', '부목사', '2000.03', '2008.02', '교구']],
    '전임', '대구광역시, 경상북도', '400', '부목사, 행정', '행정부', '2026.08.09'],
  ['최하늘', '여', '1994.12.24', '광주광역시 남구', '청년부 큐티 모임과 소그룹을 섬기는 전도사',
    [['호남신학대학교', '신학과', '2013.03', '2017.02', '졸업'], ['호남신학대학교 신학대학원', '목회학석사(M.Div.)', '2018.03', '2021.02', '졸업']],
    [['광주양림교회', '전도사', '2021.03', '2026.08', '청년부 소그룹, 큐티 나눔']],
    '준전임', '광주광역시', '190', '전도사', '청년부', '2026.08.08'],
  ['권혁준', '남', '1990.02.02', '충청남도 아산시', '농촌교회 협력과 다음세대 사역 전도사',
    [['목원대학교 신학대학원', '목회학석사(M.Div.)', '2015.03', '2018.02', '졸업']],
    [['아산제일감리교회', '전도사', '2018.03', '2026.08', '중고등부, 농촌교회 연합행사']],
    '전임', '충청남도, 세종특별자치시', '260', '전도사', '중고등부', '2026.08.07'],
  ['황보라', '여', '1996.05.05', '서울특별시 동작구', '피아노 반주·편곡이 가능한 예배 음악 사역자',
    [['서울신학대학교', '교회음악과', '2015.03', '2019.02', '졸업'], ['연세대학교 연합신학대학원', '교회음악', '2020.03', '2022.02', '졸업']],
    [['동작중앙교회', '반주자', '2019.03', '2026.08', '주일 대예배 반주, 찬양팀 편곡']],
    '파트', '서울특별시', '130', '반주자', '성가대, 찬양팀', '2026.08.06'],
  ['노승민', '남', '1996.08.31', '경기도 수원시 팔달구', '초등부와 어린이 캠프를 섬기는 교육전도사',
    [['아신대학교', '신학과', '2015.03', '2021.02', '졸업']],
    [['팔달교회', '교육전도사', '2021.03', '2026.08', '초등부 담당, 어린이 캠프']],
    '파트', '경기도', '130', '교육전도사', '초등부', '2026.08.05'],
  ['엄지혜', '여', '1989.09.19', '부산광역시 해운대구', '가정사역과 부부 세미나를 섬기는 전도사',
    [['고신대학교', '기독교상담학과', '2008.03', '2012.02', '졸업'], ['고신대학교 신학대학원', '목회학석사(M.Div.)', '2013.03', '2016.02', '졸업']],
    [['해운대감리교회', '전도사', '2016.03', '2026.08', '가정사역부, 부부 세미나']],
    '전임', '부산광역시', '270', '전도사, 가정사역', '장년부, 가정사역부', '2026.08.04'],
  ['차윤호', '남', '1984.12.08', '서울특별시 영등포구', '영상·방송 사역 총괄 경험자',
    [['감리교신학대학교 신학대학원', '목회학석사(M.Div.)', '2011.03', '2014.02', '졸업'], ['중앙대학교', '영화학과', '2003.03', '2009.02', '졸업']],
    [['영등포중앙교회', '부목사', '2017.03', '2026.08', '방송실 총괄, 온라인 사역'], ['당산교회', '전도사', '2014.03', '2017.02', '청년부']],
    '전임', '서울특별시, 경기도', '340', '부목사, 미디어사역', '미디어부, 청년부', '2026.08.03'],
  ['길소연', '여', '1999.06.13', '전라남도 순천시', '유치부·유년부를 섬기는 신학생',
    [['광신대학교', '신학과', '2018.03', '2022.02', '졸업'], ['광신대학교 신학대학원', '목회학석사(M.Div.)', '2023.03', '', '재학']],
    [['순천중앙교회', '교육전도사', '2022.03', '2026.08', '유치부·유년부']],
    '파트', '전라남도, 광주광역시', '110', '교육전도사', '유치부, 유년부', '2026.08.02'],
  ['표진우', '남', '1973.10.26', '경기도 고양시 덕양구', '기도·말씀 중심의 장년 목양 목사',
    [['총신대학교 신학대학원', '목회학석사(M.Div.)', '1997.03', '2000.02', '졸업']],
    [['덕양교회', '부목사', '2006.03', '2026.08', '장년 교구, 새벽기도 인도'], ['고양중앙교회', '전도사', '2000.03', '2006.02', '청년부']],
    '전임', '경기도, 서울특별시', '380', '부목사', '장년부, 교구', '2026.08.01'],
  ['봉하은', '여', '1993.01.31', '대전광역시 유성구', '청소년 멘토링과 진로 상담 사역자',
    [['한남대학교', '기독교학과', '2012.03', '2016.02', '졸업'], ['침례신학대학교 신학대학원', '기독교상담학', '2017.03', '2020.02', '졸업']],
    [['유성제일교회', '전도사', '2020.03', '2026.08', '고등부 멘토링, 진로 상담']],
    '준전임', '대전광역시, 세종특별자치시', '210', '전도사, 상담', '고등부', '2026.07.31'],
  ['마준영', '남', '1998.04.22', '경상남도 진주시', '대학부와 캠퍼스 전도를 섬기는 교육전도사',
    [['고신대학교', '신학과', '2017.03', '2023.02', '졸업']],
    [['진주성남교회', '교육전도사', '2023.03', '2026.08', '대학부, 캠퍼스 전도']],
    '파트', '경상남도', '130', '교육전도사', '대학부', '2026.07.30'],
  ['진서영', '여', '1974.03.17', '서울특별시 강동구', '권사회·여전도회와 중보기도 사역 전도사',
    [['감리교신학대학교 신학대학원', '목회학석사(M.Div.)', '2005.03', '2008.02', '졸업']],
    [['강동감리교회', '전도사', '2010.03', '2026.06', '여전도회, 중보기도팀']],
    '전임', '서울특별시', '260', '전도사, 기도사역', '여전도회, 장년부', '2026.07.29'],
  ['탁현수', '남', '1991.07.15', '강원특별자치도 강릉시', '청년부와 찬양팀을 함께 세우는 전도사',
    [['강원대학교', '음악교육과', '2010.03', '2016.02', '졸업'], ['감리교신학대학교 신학대학원', '목회학석사(M.Div.)', '2016.03', '2019.02', '졸업']],
    [['강릉중앙교회', '전도사', '2019.03', '2026.08', '청년부, 찬양팀 인도']],
    '전임', '강원특별자치도', '270', '전도사, 찬양인도', '청년부, 찬양팀', '2026.07.28'],
  ['우예슬', '여', '1997.09.02', '경기도 남양주시', '청소년부 예배와 제자훈련을 섬기는 전도사',
    [['총신대학교', '기독교교육과', '2016.03', '2020.02', '졸업'], ['총신대학교 신학대학원', '목회학석사(M.Div.)', '2021.03', '2024.02', '졸업']],
    [['남양주사랑교회', '전도사', '2021.03', '2026.08', '중등부 예배, 제자훈련반']],
    '준전임', '경기도, 서울특별시', '200', '전도사', '중등부', '2026.07.27'],
];

const CALLING_LINES = [
  '대학 시절 선교단체 수련회에서 "내 양을 먹이라"는 말씀 앞에 부르심을 확인했습니다.',
  '모태신앙으로 자랐지만 고등학교 때 수련회에서 개인적으로 주님을 만나 사역자의 길을 결단했습니다.',
  '직장생활 중 말씀묵상 모임을 섬기며 복음을 전하는 기쁨을 알게 되어 신학의 길로 들어섰습니다.',
  '어려운 가정 형편 속에서 교회 공동체의 돌봄을 받으며, 받은 사랑을 흘려보내는 사역자가 되기로 다짐했습니다.',
];

const PHILOSOPHY_LINES = [
  '말씀이 삶이 되는 공동체를 세우는 것이 사역의 중심입니다. 프로그램보다 한 사람을 끝까지 돌보는 목양을 지향합니다.',
  '예배가 살아나면 공동체가 살아난다고 믿습니다. 준비된 예배와 따뜻한 관계 안에서 성도가 자라도록 돕고자 합니다.',
  '담임목사님의 목회 방향에 순종하며 동역자들과 한 팀으로 움직이는 것을 가장 중요하게 여깁니다.',
  '다음세대가 교회를 떠나지 않도록 가정과 교회가 함께 신앙을 전수하는 구조를 만드는 데 힘쓰고 있습니다.',
];

const SERMON_TITLES = [
  ['포도나무와 가지', '요한복음 15:1-8'],
  ['두려워하지 말라', '이사야 41:10'],
  ['잃은 양을 찾으시는 목자', '누가복음 15:1-7'],
  ['믿음으로 걷는 길', '히브리서 11:8-10'],
  ['성령의 열매', '갈라디아서 5:22-23'],
  ['광야에서 만나는 하나님', '출애굽기 16:1-15'],
];
const WORSHIP_SONGS = ['주 품에', '은혜', '예수 우리 왕이여', '물이 바다 덮음 같이', '나의 안에 거하라', '살아계신 주'];
const PHOTO_CAPTIONS = [
  ['여름성경학교', '아이들과 함께한 3일간의 여름성경학교'],
  ['수련회', '공동체가 함께한 여름 수련회 저녁집회'],
  ['새가족 환영회', '새가족 5주 과정 수료 후 환영회'],
  ['지역 봉사', '교회 인근 독거어르신 반찬 나눔 봉사'],
  ['성탄절 발표회', '성탄절 부서 발표회 준비와 공연'],
  ['소그룹 모임', '주중 소그룹 말씀나눔 모임'],
];

// 역할에 따라 설교영상/찬양영상 비중을 다르게
function buildPortfolio(seed: Seed, index: number): PortfolioItem[] {
  const [, , , , , , career, , , , hopeRoles, hopeDepartment] = seed;
  const [company] = career[0];
  const dept = hopeDepartment.split(',')[0].trim();
  const isWorship = /찬양|반주|지휘|예배기획/.test(hopeRoles);
  const isPreacher = /담임|부목사|영어/.test(hopeRoles);
  const sermonCount = isPreacher ? 2 : 1;
  const worshipCount = isWorship ? 2 : 1;
  const photoCount = 3 + (index % 2);
  const items: PortfolioItem[] = [];

  for (let i = 0; i < sermonCount; i++) {
    const [theme, verse] = SERMON_TITLES[(index + i * 3) % SERMON_TITLES.length];
    items.push({
      category: '설교영상',
      title: `${isPreacher ? '주일설교' : `${dept} 예배 설교`} | ${theme}`,
      church: company,
      date: `2026.0${(index + i) % 8 + 1}.${String(((index * 7 + i * 3) % 4) * 7 + 1).padStart(2, '0')}`,
      description: `본문: ${verse}`,
      link: '',
      image: mockSermonThumb(index + i),
    });
  }
  for (let i = 0; i < worshipCount; i++) {
    const song = WORSHIP_SONGS[(index + i * 2) % WORSHIP_SONGS.length];
    items.push({
      category: '찬양영상',
      title: `${isWorship ? '주일예배 찬양 인도' : `${dept} 찬양`} | ${song}`,
      church: company,
      date: `2026.0${(index + i + 2) % 8 + 1}.${String(((index * 5 + i) % 4) * 7 + 3).padStart(2, '0')}`,
      description: isWorship ? '인도 및 편곡' : '부서 예배 찬양 인도',
      link: '',
      image: mockWorshipThumb(index + i),
    });
  }
  for (let i = 0; i < photoCount; i++) {
    const [title, description] = PHOTO_CAPTIONS[(index + i) % PHOTO_CAPTIONS.length];
    items.push({
      category: '사역사진',
      title,
      church: company,
      date: `2025.${String((index + i * 3) % 12 + 1).padStart(2, '0')}`,
      description,
      link: '',
      image: mockMinistryPhoto(index + i),
    });
  }
  return items;
}

function buildSelfIntroduction(seed: Seed, index: number): SelfIntroItem[] {
  const [, , , , , edu, career, hopeType, , , hopeRoles, hopeDepartment] = seed;
  const latest = career[0];
  const school = edu[0];
  return [
    {
      question: '신앙고백 및 소명',
      answer: `${CALLING_LINES[index % CALLING_LINES.length]} 이후 ${school[0]}에서 ${school[1]}을(를) 공부하며 말씀과 교회를 섬기는 사역자로 준비되어 왔습니다.`,
    },
    {
      question: '사역 경험',
      answer: career
        .map(([company, position, start, end, desc]) => `${company}에서 ${position}(으)로 ${start}~${end || '현재'} 섬기며 ${desc}을(를) 담당했습니다.`)
        .join(' '),
    },
    {
      question: '사역 철학',
      answer: PHILOSOPHY_LINES[index % PHILOSOPHY_LINES.length],
    },
    {
      question: '지원 동기 및 포부',
      answer: `${latest[0]}에서의 ${latest[1]} 경험을 바탕으로 ${hopeDepartment} ${hopeRoles} ${hopeType} 사역에 헌신하고자 합니다. 섬기게 될 교회의 비전에 맞추어 성실하게 동역하겠습니다.`,
    },
  ];
}

function calcAge(birth: string) {
  const [y, m, d] = birth.split('.').map(Number);
  const today = new Date(2026, 8, 26);
  let age = today.getFullYear() - y;
  if (today.getMonth() + 1 < m || (today.getMonth() + 1 === m && today.getDate() < d)) age -= 1;
  return String(age);
}

function maskName(name: string) {
  if (name.length <= 1) return name;
  if (name.length === 2) return `${name[0]}*`;
  return `${name[0]}${'*'.repeat(name.length - 2)}${name[name.length - 1]}`;
}

export const MOCK_MINISTER_DETAILS: MinisterInfoDetail[] = SEEDS.map((seed, index) => {
  const [name, gender, birth, address, title, edu, career, hopeType, hopeLocation, hopeSalary, hopeRoles, hopeDepartment, updatedAt] = seed;
  const [birthYear, birthMonth, birthDay] = birth.split('.');
  return {
    id: `${MOCK_ID_PREFIX}${index + 1}`,
    title,
    name,
    gender,
    birthYear,
    birthMonth,
    birthDay,
    ageText: calcAge(birth),
    phone: `010-${String(1000 + index * 37).padStart(4, '0')}-${String(5000 + index * 113).slice(0, 4)}`,
    email: `minister${index + 1}@example.com`,
    address,
    addressDetail: '',
    // 상단 고정 샘플(첫 번째)은 증명사진 대신 로고
    profileImage: index === 0 ? logoPng : samplePhotoOf(name),
    educationItems: edu.map(([schoolName, major, startDate, endDate, status]) => ({ schoolName, major, startDate, endDate, status, description: '' })),
    careerItems: career.map(([companyName, position, startDate, endDate, description]) => ({ companyName, position, startDate, endDate, description })),
    hopeType,
    hopeLocation,
    hopeSalary,
    hopeSalaryPaySort: '월',
    hopeRoles,
    hopeDepartment,
    hopeInsurance: hopeType === '파트' ? '' : '4대보험',
    hopeWelfare: hopeType === '전임' ? '사택 제공, 퇴직금' : '',
    updatedAt,
    selfIntroduction: buildSelfIntroduction(seed, index),
    portfolioItems: buildPortfolio(seed, index),
  };
});

const MOCK_MINISTER_LIST: MinisterInfoListItem[] = MOCK_MINISTER_DETAILS.map((d) => ({
  id: d.id,
  title: d.title,
  maskedName: maskName(d.name),
  gender: d.gender,
  ageText: d.ageText,
  region: d.address.split(' ').slice(0, 2).join(' '),
  profileImage: d.profileImage,
  educationItems: d.educationItems,
  careerItems: d.careerItems,
  hopeType: d.hopeType,
  hopeLocation: d.hopeLocation,
  hopeRoles: d.hopeRoles,
  hopeDepartment: d.hopeDepartment,
  updatedAt: d.updatedAt,
  hasSelfIntroduction: (d.selfIntroduction?.length ?? 0) > 0,
  portfolioCount: d.portfolioItems?.length ?? 0,
}));

interface MockListQuery {
  search: string;
  hopeType: string[];
  city: string[];
  gender: string;
}

// 누구나 상세까지 볼 수 있는 샘플 1건 — 목록 상단 별도 영역, 일반 목록에서는 제외
export const SAMPLE_MINISTER_ID = MOCK_MINISTER_DETAILS[0].id;

export function getSampleMinisterListItem() {
  return MOCK_MINISTER_LIST.find((item) => item.id === SAMPLE_MINISTER_ID) || null;
}

// 조건에 맞는 목데이터 전체 (샘플 제외) — 실제 이력서 뒤에 이어 붙인다
export function filterMockMinisterList({ search, hopeType, city, gender }: MockListQuery) {
  const searchWord = search.trim().toLowerCase();
  return MOCK_MINISTER_LIST.filter((item) => {
    if (item.id === SAMPLE_MINISTER_ID) return false;
    if (hopeType.length > 0 && !hopeType.includes(item.hopeType)) return false;
    if (gender && item.gender !== gender) return false;
    if (city.length > 0) {
      const locations = item.hopeLocation.split(',').map((loc) => loc.trim());
      if (!city.some((c) => locations.some((loc) => loc.startsWith(c)))) return false;
    }
    if (searchWord) {
      const haystack = [
        item.title,
        item.hopeRoles,
        item.hopeDepartment,
        item.hopeLocation,
        ...item.educationItems.map((e) => `${e.schoolName} ${e.major}`),
        ...item.careerItems.map((c) => `${c.companyName} ${c.position} ${c.description}`),
      ].join(' ').toLowerCase();
      if (!haystack.includes(searchWord)) return false;
    }
    return true;
  });
}

export function getMockMinisterDetail(id: string) {
  return MOCK_MINISTER_DETAILS.find((d) => d.id === id) || null;
}
